// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
    background-color: #f0f0f0; /* Light gray background for the entire page */
}

.szakjelentesek {
    padding: 20px;
    padding-top: 80px; /* Account for navbar (60px) plus some spacing */
    background-color: #f0f0f0;
    min-height: 100vh;
}

/* Új fejléc konténer a cím és gomb igazításához */
.header-container {
    display: grid;
    grid-template-columns: minmax(0, 1fr) auto minmax(0, 1fr);
    align-items: center; /* Középre igazítás függőlegesen */
    gap: 20px;
    margin-bottom: 20px; /* Extra spacing below the header */
    padding: 0 20px; /* Adj egy kis belső margót */
}

.header-container h1 {
    font-size: 2.5rem; /* Larger font size for the header */
    margin: 0;
    font-weight: bold; /* Bold font style */
    margin-left: -20px; /* A címet x px-el balra tolja */
}

.deadline-warning {
    grid-column: 2;
    margin: 0;
    text-align: center;
    color: #b42318;
    font-weight: bold;
}

.header-container .create-button,
.header-container .view-toggle-button {
    grid-column: 3;
    justify-self: end;
    width: 190px;
}

@media (max-width: 1100px) {
    .header-container {
        grid-template-columns: 1fr auto;
    }

    .deadline-warning {
        grid-column: 1 / -1;
        grid-row: 2;
    }

    .header-container .create-button,
    .header-container .view-toggle-button {
        grid-column: 2;
        grid-row: 1;
    }
}

@media (max-width: 600px) {
    .header-container {
        grid-template-columns: 1fr;
    }

    .header-container .create-button,
    .header-container .view-toggle-button {
        grid-column: 1;
        grid-row: 3;
        justify-self: start;
    }
}



.button-row {
    display: flex;
    justify-content: flex-end; /* Align the button to the right */
    margin-bottom: 20px; /* Add spacing below the button */
}

/* Új szakjelentés létrehozásának gomb */
.create-button {
    background-color: #44ACC9; /* Default blue color */
    color: white;
    border: none;
    padding: 10px 20px;
    border-radius: 5px;
    cursor: pointer;
    font-size: 16px;
    display: flex;
    align-items: center; /* Vertically align the icon and text */
    justify-content: center; /* Center-align icon and text */
    gap: 8px; /* Add spacing between icon and text */
}


.create-button:hover {
    background-color: #3a94b1; /* Darker blue on hover */
}

.create-button:disabled,
.create-button:disabled:hover {
    background-color: #a0a0a0;
    cursor: not-allowed;
}

.view-toggle-button {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 44px;
    border: none;
    border-radius: 5px;
    color: white;
    cursor: pointer;
}

.view-toggle-missing {
    background-color: #dc3545;
}

.view-toggle-missing:hover {
    background-color: #c82333;
}

.view-toggle-back {
    background-color: #28a745;
}

.view-toggle-back:hover {
    background-color: #218838;
}

.plus-icon {
    font-size: 20px; /* Adjust icon size */
}

.search-bar {
    display: flex;
    justify-content: center; /* Center-align the search bar */
    margin-bottom: 20px; /* Add spacing below the search bar */
}

.search-bar input {
    width: 50%; /* Wider input field */
    padding: 10px;
    font-size: 1.2rem; /* Larger font size */
    border: 1px solid #ccc;
    border-radius: 5px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1); /* Subtle shadow */
    transition: all 0.3s ease; /* Smooth transition for focus effect */
}

.search-bar input:focus {
    outline: none;
    border-color: #44ACC9; /* Highlight border color on focus */
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2); /* Stronger shadow on focus */
}

.filters {
    display: flex;
    justify-content: center; /* A mezők középre igazítása */
    gap: 20px; /* Távolság a szűrők között */
    margin-bottom: 20px; /* Extra hely az alsó részhez */
    flex-wrap: wrap; /* Több sorba törés kis képernyőkön */
}

.filter {
    display: flex;
    flex-direction: column;
    align-items: flex-start; /* Balra igazítás */
    width: 200px; /* Egyforma szélesség minden mezőnek */
}

.filter label {
    margin-bottom: 5px;
    font-size: 1rem;
    color: #555;
    text-align: left; /* Balra igazítás */
    width: 100%; /* Ugyanakkora szélesség, mint az input */
}

.filter select,
.filter input {
    width: 100%; /* Kitöltik a rendelkezésre álló helyet */
    padding: 8px;
    font-size: 1rem;
    border: 1px solid #ccc;
    border-radius: 5px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1); /* Halvány árnyék */
    transition: all 0.3s ease;
}

.filter select:focus,
.filter input:focus {
    outline: none;
    border-color: #44ACC9;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
}

.missing-reports-message {
    text-align: center;
    color: #555;
}


.table-container {
    width: 100%; /* Full-width table */
    margin-left: auto;
    margin-right: auto;
    padding-right: 5px; /* Extra padding for scrollbar space */
}

.szakjelentesek table {
    width: 100%; /* Full table width */
    border-collapse: collapse;
    border: none;
    border-radius: 10px;
    background-color: white;
    overflow-x: hidden; /* Hide horizontal scrollbar */
}

.szakjelentesek th,
.szakjelentesek td {
    padding: 10px;
    text-align: left;
    border-bottom: 1px solid #f0f0f0; /* Row separator matching the background */
}

.szakjelentesek th {
    color: #555555; /* Light gray text color for headers */
    font-weight: normal; /* No bold */
}

.szakjelentesek td {
    color: black; /* Black text color for data */
}

/* Highlight rows on hover */
.szakjelentesek tbody tr:hover {
    background-color: #e0e0e0 !important; /* Light gray background for hovered rows */
    cursor: pointer; /* Pointer cursor to indicate clickability */
}

.szakjelentesek .missing-reports-table tbody tr:hover {
    background-color: white !important;
    cursor: default;
}

.floating-action-button {
    position: fixed;
    bottom: 20px;
    right: 20px;
    background-color: #44ACC9;
    color: white;
    border: none;
    border-radius: 50px;
    padding: 15px 20px;
    font-size: 16px;
    box-shadow: 2px 2px 10px rgba(0, 0, 0, 0.2);
    cursor: pointer;
    transition: all 0.3s ease-in-out;
}

.floating-action-button:hover {
    background-color: #44ACC9;
}
.floating-bottom-right {
    position: fixed;
    bottom: 20px;
    right: 20px;
    z-index: 1000;
}

.floating-bottom-left {
    position: fixed;
    bottom: 20px;
    left: 20px;
    z-index: 1000;
}

.download-button {
    background-color: #28a745; /* Green color for download */
    color: white;
    border: none;
    border-radius: 25px;
    padding: 12px 20px;
    font-size: 14px;
    box-shadow: 2px 2px 10px rgba(0, 0, 0, 0.2);
    cursor: pointer;
    transition: all 0.3s ease-in-out;
    display: flex;
    align-items: center;
    gap: 8px;
}

.download-button:hover {
    background-color: #218838; /* Darker green on hover */
    transform: translateY(-2px);
}

.download-icon {
    font-size: 18px;
}

.finalize-button {
    background-color: #dc3545; /* Red color for finalize */
    color: white;
    border: none;
    border-radius: 25px;
    padding: 12px 20px;
    font-size: 14px;
    box-shadow: 2px 2px 10px rgba(0, 0, 0, 0.2);
    cursor: pointer;
    transition: all 0.3s ease-in-out;
}

.finalize-button:hover {
    background-color: #c82333; /* Darker red on hover */
    transform: translateY(-2px);
}

/* Rendezhető fejlécek stílusa */
.sortable-th {
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  transition: background-color 0.2s ease;
}

.sortable-th:hover {
  background-color: rgba(0, 0, 0, 0.05);
}

.th-content {
  display: inline-flex;
  align-items: center;
  gap: 6px;
}

.sort-icon {
  font-size: 0.85em;
  line-height: 1;
}

.sort-icon.default {
  color: #a0aec0;
}

.sort-icon.active {
  color: #44acc9;
}

.report-progress-overlay {
    position: fixed;
    inset: 0;
    z-index: 1200;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 20px;
}

.report-progress-modal {
    width: min(100%, 540px);
    max-height: 85vh;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    background: #f8f9fa;
    border-radius: 12px;
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.25);
    outline: none;
}

.report-progress-header {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    gap: 16px;
    padding: 24px;
}

.report-progress-header h2 {
    margin: 0;
    font-size: 1.3rem;
    min-width: 0;
    overflow-wrap: anywhere;
}

.report-progress-body {
    min-height: 0;
    overflow-y: auto;
    padding: 0 24px 24px;
}

.report-progress-close {
    margin: 0;
    padding: 0;
    border: 0;
    background: transparent;
    color: #333;
    font-size: 28px;
    line-height: 1;
    cursor: pointer;
}

.report-progress-close:hover {
    background: transparent;
    color: #000;
}
`, "",{"version":3,"sources":["webpack://./src/routes/Szakjelentesek.css"],"names":[],"mappings":"AAAA;IACI,yBAAyB,EAAE,8CAA8C;AAC7E;;AAEA;IACI,aAAa;IACb,iBAAiB,EAAE,gDAAgD;IACnE,yBAAyB;IACzB,iBAAiB;AACrB;;AAEA,kDAAkD;AAClD;IACI,aAAa;IACb,yDAAyD;IACzD,mBAAmB,EAAE,kCAAkC;IACvD,SAAS;IACT,mBAAmB,EAAE,mCAAmC;IACxD,eAAe,EAAE,6BAA6B;AAClD;;AAEA;IACI,iBAAiB,EAAE,oCAAoC;IACvD,SAAS;IACT,iBAAiB,EAAE,oBAAoB;IACvC,kBAAkB,EAAE,gCAAgC;AACxD;;AAEA;IACI,cAAc;IACd,SAAS;IACT,kBAAkB;IAClB,cAAc;IACd,iBAAiB;AACrB;;AAEA;;IAEI,cAAc;IACd,iBAAiB;IACjB,YAAY;AAChB;;AAEA;IACI;QACI,+BAA+B;IACnC;;IAEA;QACI,mBAAmB;QACnB,WAAW;IACf;;IAEA;;QAEI,cAAc;QACd,WAAW;IACf;AACJ;;AAEA;IACI;QACI,0BAA0B;IAC9B;;IAEA;;QAEI,cAAc;QACd,WAAW;QACX,mBAAmB;IACvB;AACJ;;;;AAIA;IACI,aAAa;IACb,yBAAyB,EAAE,kCAAkC;IAC7D,mBAAmB,EAAE,iCAAiC;AAC1D;;AAEA,wCAAwC;AACxC;IACI,yBAAyB,EAAE,uBAAuB;IAClD,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,aAAa;IACb,mBAAmB,EAAE,uCAAuC;IAC5D,uBAAuB,EAAE,+BAA+B;IACxD,QAAQ,EAAE,sCAAsC;AACpD;;;AAGA;IACI,yBAAyB,EAAE,yBAAyB;AACxD;;AAEA;;IAEI,yBAAyB;IACzB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,eAAe,EAAE,qBAAqB;AAC1C;;AAEA;IACI,aAAa;IACb,uBAAuB,EAAE,gCAAgC;IACzD,mBAAmB,EAAE,qCAAqC;AAC9D;;AAEA;IACI,UAAU,EAAE,sBAAsB;IAClC,aAAa;IACb,iBAAiB,EAAE,qBAAqB;IACxC,sBAAsB;IACtB,kBAAkB;IAClB,wCAAwC,EAAE,kBAAkB;IAC5D,yBAAyB,EAAE,uCAAuC;AACtE;;AAEA;IACI,aAAa;IACb,qBAAqB,EAAE,oCAAoC;IAC3D,wCAAwC,EAAE,6BAA6B;AAC3E;;AAEA;IACI,aAAa;IACb,uBAAuB,EAAE,8BAA8B;IACvD,SAAS,EAAE,6BAA6B;IACxC,mBAAmB,EAAE,+BAA+B;IACpD,eAAe,EAAE,qCAAqC;AAC1D;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB,EAAE,mBAAmB;IAC5C,YAAY,EAAE,sCAAsC;AACxD;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,WAAW;IACX,gBAAgB,EAAE,mBAAmB;IACrC,WAAW,EAAE,yCAAyC;AAC1D;;AAEA;;IAEI,WAAW,EAAE,yCAAyC;IACtD,YAAY;IACZ,eAAe;IACf,sBAAsB;IACtB,kBAAkB;IAClB,wCAAwC,EAAE,mBAAmB;IAC7D,yBAAyB;AAC7B;;AAEA;;IAEI,aAAa;IACb,qBAAqB;IACrB,wCAAwC;AAC5C;;AAEA;IACI,kBAAkB;IAClB,WAAW;AACf;;;AAGA;IACI,WAAW,EAAE,qBAAqB;IAClC,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB,EAAE,sCAAsC;AAC9D;;AAEA;IACI,WAAW,EAAE,qBAAqB;IAClC,yBAAyB;IACzB,YAAY;IACZ,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB,EAAE,8BAA8B;AACtD;;AAEA;;IAEI,aAAa;IACb,gBAAgB;IAChB,gCAAgC,EAAE,0CAA0C;AAChF;;AAEA;IACI,cAAc,EAAE,sCAAsC;IACtD,mBAAmB,EAAE,YAAY;AACrC;;AAEA;IACI,YAAY,EAAE,8BAA8B;AAChD;;AAEA,4BAA4B;AAC5B;IACI,oCAAoC,EAAE,2CAA2C;IACjF,eAAe,EAAE,4CAA4C;AACjE;;AAEA;IACI,kCAAkC;IAClC,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,YAAY;IACZ,WAAW;IACX,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;IACf,2CAA2C;IAC3C,eAAe;IACf,gCAAgC;AACpC;;AAEA;IACI,yBAAyB;AAC7B;AACA;IACI,eAAe;IACf,YAAY;IACZ,WAAW;IACX,aAAa;AACjB;;AAEA;IACI,eAAe;IACf,YAAY;IACZ,UAAU;IACV,aAAa;AACjB;;AAEA;IACI,yBAAyB,EAAE,6BAA6B;IACxD,YAAY;IACZ,YAAY;IACZ,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;IACf,2CAA2C;IAC3C,eAAe;IACf,gCAAgC;IAChC,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,yBAAyB,EAAE,0BAA0B;IACrD,2BAA2B;AAC/B;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,yBAAyB,EAAE,2BAA2B;IACtD,YAAY;IACZ,YAAY;IACZ,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;IACf,2CAA2C;IAC3C,eAAe;IACf,gCAAgC;AACpC;;AAEA;IACI,yBAAyB,EAAE,wBAAwB;IACnD,2BAA2B;AAC/B;;AAEA,gCAAgC;AAChC;EACE,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;EACjB,sCAAsC;AACxC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;IACI,eAAe;IACf,QAAQ;IACR,aAAa;IACb,oCAAoC;IACpC,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,aAAa;AACjB;;AAEA;IACI,uBAAuB;IACvB,gBAAgB;IAChB,sBAAsB;IACtB,aAAa;IACb,sBAAsB;IACtB,gBAAgB;IAChB,mBAAmB;IACnB,mBAAmB;IACnB,0CAA0C;IAC1C,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,uBAAuB;IACvB,SAAS;IACT,aAAa;AACjB;;AAEA;IACI,SAAS;IACT,iBAAiB;IACjB,YAAY;IACZ,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,gBAAgB;IAChB,oBAAoB;AACxB;;AAEA;IACI,SAAS;IACT,UAAU;IACV,SAAS;IACT,uBAAuB;IACvB,WAAW;IACX,eAAe;IACf,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,uBAAuB;IACvB,WAAW;AACf","sourcesContent":["body {\n    background-color: #f0f0f0; /* Light gray background for the entire page */\n}\n\n.szakjelentesek {\n    padding: 20px;\n    padding-top: 80px; /* Account for navbar (60px) plus some spacing */\n    background-color: #f0f0f0;\n    min-height: 100vh;\n}\n\n/* Új fejléc konténer a cím és gomb igazításához */\n.header-container {\n    display: grid;\n    grid-template-columns: minmax(0, 1fr) auto minmax(0, 1fr);\n    align-items: center; /* Középre igazítás függőlegesen */\n    gap: 20px;\n    margin-bottom: 20px; /* Extra spacing below the header */\n    padding: 0 20px; /* Adj egy kis belső margót */\n}\n\n.header-container h1 {\n    font-size: 2.5rem; /* Larger font size for the header */\n    margin: 0;\n    font-weight: bold; /* Bold font style */\n    margin-left: -20px; /* A címet x px-el balra tolja */\n}\n\n.deadline-warning {\n    grid-column: 2;\n    margin: 0;\n    text-align: center;\n    color: #b42318;\n    font-weight: bold;\n}\n\n.header-container .create-button,\n.header-container .view-toggle-button {\n    grid-column: 3;\n    justify-self: end;\n    width: 190px;\n}\n\n@media (max-width: 1100px) {\n    .header-container {\n        grid-template-columns: 1fr auto;\n    }\n\n    .deadline-warning {\n        grid-column: 1 / -1;\n        grid-row: 2;\n    }\n\n    .header-container .create-button,\n    .header-container .view-toggle-button {\n        grid-column: 2;\n        grid-row: 1;\n    }\n}\n\n@media (max-width: 600px) {\n    .header-container {\n        grid-template-columns: 1fr;\n    }\n\n    .header-container .create-button,\n    .header-container .view-toggle-button {\n        grid-column: 1;\n        grid-row: 3;\n        justify-self: start;\n    }\n}\n\n\n\n.button-row {\n    display: flex;\n    justify-content: flex-end; /* Align the button to the right */\n    margin-bottom: 20px; /* Add spacing below the button */\n}\n\n/* Új szakjelentés létrehozásának gomb */\n.create-button {\n    background-color: #44ACC9; /* Default blue color */\n    color: white;\n    border: none;\n    padding: 10px 20px;\n    border-radius: 5px;\n    cursor: pointer;\n    font-size: 16px;\n    display: flex;\n    align-items: center; /* Vertically align the icon and text */\n    justify-content: center; /* Center-align icon and text */\n    gap: 8px; /* Add spacing between icon and text */\n}\n\n\n.create-button:hover {\n    background-color: #3a94b1; /* Darker blue on hover */\n}\n\n.create-button:disabled,\n.create-button:disabled:hover {\n    background-color: #a0a0a0;\n    cursor: not-allowed;\n}\n\n.view-toggle-button {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    height: 44px;\n    border: none;\n    border-radius: 5px;\n    color: white;\n    cursor: pointer;\n}\n\n.view-toggle-missing {\n    background-color: #dc3545;\n}\n\n.view-toggle-missing:hover {\n    background-color: #c82333;\n}\n\n.view-toggle-back {\n    background-color: #28a745;\n}\n\n.view-toggle-back:hover {\n    background-color: #218838;\n}\n\n.plus-icon {\n    font-size: 20px; /* Adjust icon size */\n}\n\n.search-bar {\n    display: flex;\n    justify-content: center; /* Center-align the search bar */\n    margin-bottom: 20px; /* Add spacing below the search bar */\n}\n\n.search-bar input {\n    width: 50%; /* Wider input field */\n    padding: 10px;\n    font-size: 1.2rem; /* Larger font size */\n    border: 1px solid #ccc;\n    border-radius: 5px;\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1); /* Subtle shadow */\n    transition: all 0.3s ease; /* Smooth transition for focus effect */\n}\n\n.search-bar input:focus {\n    outline: none;\n    border-color: #44ACC9; /* Highlight border color on focus */\n    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2); /* Stronger shadow on focus */\n}\n\n.filters {\n    display: flex;\n    justify-content: center; /* A mezők középre igazítása */\n    gap: 20px; /* Távolság a szűrők között */\n    margin-bottom: 20px; /* Extra hely az alsó részhez */\n    flex-wrap: wrap; /* Több sorba törés kis képernyőkön */\n}\n\n.filter {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start; /* Balra igazítás */\n    width: 200px; /* Egyforma szélesség minden mezőnek */\n}\n\n.filter label {\n    margin-bottom: 5px;\n    font-size: 1rem;\n    color: #555;\n    text-align: left; /* Balra igazítás */\n    width: 100%; /* Ugyanakkora szélesség, mint az input */\n}\n\n.filter select,\n.filter input {\n    width: 100%; /* Kitöltik a rendelkezésre álló helyet */\n    padding: 8px;\n    font-size: 1rem;\n    border: 1px solid #ccc;\n    border-radius: 5px;\n    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1); /* Halvány árnyék */\n    transition: all 0.3s ease;\n}\n\n.filter select:focus,\n.filter input:focus {\n    outline: none;\n    border-color: #44ACC9;\n    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);\n}\n\n.missing-reports-message {\n    text-align: center;\n    color: #555;\n}\n\n\n.table-container {\n    width: 100%; /* Full-width table */\n    margin-left: auto;\n    margin-right: auto;\n    padding-right: 5px; /* Extra padding for scrollbar space */\n}\n\n.szakjelentesek table {\n    width: 100%; /* Full table width */\n    border-collapse: collapse;\n    border: none;\n    border-radius: 10px;\n    background-color: white;\n    overflow-x: hidden; /* Hide horizontal scrollbar */\n}\n\n.szakjelentesek th,\n.szakjelentesek td {\n    padding: 10px;\n    text-align: left;\n    border-bottom: 1px solid #f0f0f0; /* Row separator matching the background */\n}\n\n.szakjelentesek th {\n    color: #555555; /* Light gray text color for headers */\n    font-weight: normal; /* No bold */\n}\n\n.szakjelentesek td {\n    color: black; /* Black text color for data */\n}\n\n/* Highlight rows on hover */\n.szakjelentesek tbody tr:hover {\n    background-color: #e0e0e0 !important; /* Light gray background for hovered rows */\n    cursor: pointer; /* Pointer cursor to indicate clickability */\n}\n\n.szakjelentesek .missing-reports-table tbody tr:hover {\n    background-color: white !important;\n    cursor: default;\n}\n\n.floating-action-button {\n    position: fixed;\n    bottom: 20px;\n    right: 20px;\n    background-color: #44ACC9;\n    color: white;\n    border: none;\n    border-radius: 50px;\n    padding: 15px 20px;\n    font-size: 16px;\n    box-shadow: 2px 2px 10px rgba(0, 0, 0, 0.2);\n    cursor: pointer;\n    transition: all 0.3s ease-in-out;\n}\n\n.floating-action-button:hover {\n    background-color: #44ACC9;\n}\n.floating-bottom-right {\n    position: fixed;\n    bottom: 20px;\n    right: 20px;\n    z-index: 1000;\n}\n\n.floating-bottom-left {\n    position: fixed;\n    bottom: 20px;\n    left: 20px;\n    z-index: 1000;\n}\n\n.download-button {\n    background-color: #28a745; /* Green color for download */\n    color: white;\n    border: none;\n    border-radius: 25px;\n    padding: 12px 20px;\n    font-size: 14px;\n    box-shadow: 2px 2px 10px rgba(0, 0, 0, 0.2);\n    cursor: pointer;\n    transition: all 0.3s ease-in-out;\n    display: flex;\n    align-items: center;\n    gap: 8px;\n}\n\n.download-button:hover {\n    background-color: #218838; /* Darker green on hover */\n    transform: translateY(-2px);\n}\n\n.download-icon {\n    font-size: 18px;\n}\n\n.finalize-button {\n    background-color: #dc3545; /* Red color for finalize */\n    color: white;\n    border: none;\n    border-radius: 25px;\n    padding: 12px 20px;\n    font-size: 14px;\n    box-shadow: 2px 2px 10px rgba(0, 0, 0, 0.2);\n    cursor: pointer;\n    transition: all 0.3s ease-in-out;\n}\n\n.finalize-button:hover {\n    background-color: #c82333; /* Darker red on hover */\n    transform: translateY(-2px);\n}\n\n/* Rendezhető fejlécek stílusa */\n.sortable-th {\n  cursor: pointer;\n  user-select: none;\n  transition: background-color 0.2s ease;\n}\n\n.sortable-th:hover {\n  background-color: rgba(0, 0, 0, 0.05);\n}\n\n.th-content {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.sort-icon {\n  font-size: 0.85em;\n  line-height: 1;\n}\n\n.sort-icon.default {\n  color: #a0aec0;\n}\n\n.sort-icon.active {\n  color: #44acc9;\n}\n\n.report-progress-overlay {\n    position: fixed;\n    inset: 0;\n    z-index: 1200;\n    background-color: rgba(0, 0, 0, 0.5);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    padding: 20px;\n}\n\n.report-progress-modal {\n    width: min(100%, 540px);\n    max-height: 85vh;\n    box-sizing: border-box;\n    display: flex;\n    flex-direction: column;\n    overflow: hidden;\n    background: #f8f9fa;\n    border-radius: 12px;\n    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.25);\n    outline: none;\n}\n\n.report-progress-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: flex-start;\n    gap: 16px;\n    padding: 24px;\n}\n\n.report-progress-header h2 {\n    margin: 0;\n    font-size: 1.3rem;\n    min-width: 0;\n    overflow-wrap: anywhere;\n}\n\n.report-progress-body {\n    min-height: 0;\n    overflow-y: auto;\n    padding: 0 24px 24px;\n}\n\n.report-progress-close {\n    margin: 0;\n    padding: 0;\n    border: 0;\n    background: transparent;\n    color: #333;\n    font-size: 28px;\n    line-height: 1;\n    cursor: pointer;\n}\n\n.report-progress-close:hover {\n    background: transparent;\n    color: #000;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
